import React, {Component, createRef} from "react"
import { Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import {store} from "../../App";
import { setDialog, clearDialog } from "../../Redux/OverlayActions";

class TruckMarker extends Component {
    constructor() {
        super();
        this.markerRef = createRef();
        this.animationFrame = null;
        this.statusToText = this.statusToText.bind(this);
        this.openRouteWithDisclaimer = this.openRouteWithDisclaimer.bind(this);
    }

    componentDidMount() {
    }

    componentDidUpdate(prevProps) {
        // Animate marker when position changes
        if (prevProps.lat !== this.props.lat || prevProps.lng !== this.props.lng) {
            this.animateMarker(
                [prevProps.lat, prevProps.lng],
                [this.props.lat, this.props.lng]
            );
        }
    }

    componentWillUnmount() {
        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
        }
    }

    animateMarker(fromLatLng, toLatLng) {
        const marker = this.markerRef.current;
        if (!marker) return;

        const duration = 1000; // 1 second animation
        const startTime = performance.now();
        const startLat = fromLatLng[0];
        const startLng = fromLatLng[1];
        const deltaLat = toLatLng[0] - startLat;
        const deltaLng = toLatLng[1] - startLng;

        const animate = (currentTime) => {
            const elapsed = currentTime - startTime;
            const progress = Math.min(elapsed / duration, 1);

            // Ease-out cubic for smooth deceleration
            const easeProgress = 1 - Math.pow(1 - progress, 3);

            const newLat = startLat + (deltaLat * easeProgress);
            const newLng = startLng + (deltaLng * easeProgress);

            marker.setLatLng([newLat, newLng]);

            if (progress < 1) {
                this.animationFrame = requestAnimationFrame(animate);
            }
        };

        if (this.animationFrame) {
            cancelAnimationFrame(this.animationFrame);
        }
        this.animationFrame = requestAnimationFrame(animate);
    }

    openRouteWithDisclaimer(lat, lng) {
        const kar = this.props.kar;
        store.dispatch(setDialog({
            title: "Route plannen",
            message: `<strong>Let op:</strong> IJskar ${kar.title} kan zich intussen verplaatsen. Check regelmatig de app om te zien waar de ijskar zich bevindt.`,
            theme: "warning",
            btn1Text: "Open routeplanner",
            btn1Theme: "primary",
            btn1Title: "open",
            btn2Text: "Annuleer",
            btn2Title: "cancel",
            response: (response) => {
                store.dispatch(clearDialog());
                if (response === "open") {
                    // Open Google Maps with directions
                    const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
                    window.open(mapsUrl, '_blank');
                }
            },
        }));
    }

    statusToText(kar) {
        switch (kar.status) {
            case "STARTUP":
                return <>Vertrekt zodadelijk{(kar.status_payload?.scheduled_at_name ? <> richting {kar.status_payload?.scheduled_at_name}</> : null)}</>;
            case "EN_ROUTE_TO_ZONE":
                return <>Onderweg{(kar.status_payload?.scheduled_at_name ? <> naar {kar.status_payload?.scheduled_at_name}</> : <> naar zone</>)}</>;
            case "IN_ZONE":
                return <>Aan het rijden{(kar.status_payload?.scheduled_at_name ? <> in {kar.status_payload?.scheduled_at_name}</> : null)}</>;
            case "EN_ROUTE_TO_DEPOT":
                return <>Uitverkocht</>;
            case "CLEANUP":
                return <>Uitverkocht</>;
            case "FINISHED":
                return <>Uitverkocht</>;
            case "SCHEDULED":
                return <>Gepland{(kar.status_payload?.scheduled_at_name ? <> in {kar.status_payload?.scheduled_at_name}</> : null)}</>;
            case "NOT_SCHEDULED":
                return <>Niet gepland vandaag</>;
            case "EN_ROUTE_TO_ICECREAM_VAN_RESERVATION":
                return <>Onderweg naar reservatie</>;
            case "AT_ICECREAM_VAN_RESERVATION":
                return <>Op reservatie</>;
            case "ON_BREAK":
                return <>In pauze</>;
            default:
                return <></>;
        }
    }

    render() {
        const kar = this.props.kar;

        // Use DivIcon to combine background circle and number in one element
        const bgImage = kar.available ? "/images/tracker/icon_kar_available.png" : "/images/tracker/icon_kar_notavailable.png";
        const numberImage = "/images/tracker/icon_kar_"+(this.props.kar.id)+".png";

        const myIcon = L.divIcon({
            className: 'truck-marker-icon',
            html: `<div class="truck-marker-container">
                <img src="${bgImage}" class="truck-marker-bg" />
                <img src="${numberImage}" class="truck-marker-number" />
            </div>`,
            iconSize: [40, 40],
            iconAnchor: [20, 20],
            popupAnchor: [0, -20],
        });

        return (
            <Marker
                ref={this.markerRef}
                icon={myIcon}
                key={"karmarker"+this.props.kar.id}
                zIndexOffset={1000}
                eventHandlers={{
                    click: () => {this.props.onClick(this.props.trackid, kar.latitude, kar.longitude);}
                }}
                position={[this.props.lat, this.props.lng]}
                >
                <Popup className="truck-popup">
                    <div className="truck-popup-content">
                        <h6 className="truck-popup-title">IJskar {kar.title}</h6>
                        {kar.subtitle ? <p className="truck-popup-subtitle" dangerouslySetInnerHTML={{__html: kar.subtitle}}></p> : null}
                        <div className="truck-popup-status">
                            <span className={`status-badge ${kar.available ? 'available' : 'unavailable'}`}>
                                {kar.available ? "Beschikbaar" : "Niet beschikbaar"}
                            </span>
                            <span className="status-text">{this.statusToText(kar)}</span>
                        </div>
                        <button
                            type="button"
                            className="truck-popup-route-btn"
                            onClick={() => this.openRouteWithDisclaimer(kar.latitude, kar.longitude)}
                        >
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                                <circle cx="12" cy="10" r="3"/>
                            </svg>
                            Route plannen
                        </button>
                    </div>
                </Popup>
            </Marker>
        )
    }
}

export default TruckMarker